import { sum, zeroIfNaN } from "~/core/utils/number";
import type { Campaign } from "~/modules/campaign/models/Campaign.interface";
import { computeCampaignStatPercentage } from "~/modules/campaign/utils/campaignStatisticsComputation";

export function useGetCampaignStat(
  campaign?: Campaign | null,
): Map<string, any> {
  const stats: Map<string, any> = new Map();
  const countTotal = zeroIfNaN(campaign?.statistics?.total);

  const countPending = sum([
    campaign?.statistics?.pending,
    campaign?.statistics?.opPending,
    campaign?.statistics?.paused,
  ]);

  const countInProgress = sum([
    campaign?.statistics?.delivered,
    campaign?.statistics?.opRunning,
    campaign?.statistics?.retry,
    campaign?.statistics?.opRetry,
  ]);

  const countSuccess = sum([campaign?.statistics?.done]);

  const countFailed = sum([
    campaign?.statistics?.opCancelling,
    campaign?.statistics?.opCancelled,
    campaign?.statistics?.opError,
    campaign?.statistics?.cancelling,
    campaign?.statistics?.cancelled,
    campaign?.statistics?.error,
    campaign?.statistics?.expired,
  ]);

  stats.set("countPending", countPending);
  stats.set("countInProgress", countInProgress);
  stats.set("countSuccess", countSuccess);
  stats.set("countFailed", countFailed);

  stats.set(
    "percentPending",
    computeCampaignStatPercentage(countTotal, countPending),
  );
  stats.set(
    "percentInProgress",
    computeCampaignStatPercentage(countTotal, countInProgress),
  );
  stats.set(
    "percentSuccess",
    computeCampaignStatPercentage(countTotal, countSuccess),
  );
  stats.set(
    "percentFailed",
    computeCampaignStatPercentage(countTotal, countFailed),
  );

  return stats;
}
